const NAME_SPACE = 'jbp-plan-review'

export const TRANSLATION_KEYS = {
  successMsg: `${NAME_SPACE}-success-msg`,
  successMsgTitle: `${NAME_SPACE}-success-msg-title`,
  successMsgOk: `${NAME_SPACE}-success-msg-ok`,

  confirmMsg: `${NAME_SPACE}-confirm-msg`,
  confirmMsgTitle: `${NAME_SPACE}-confirm-msg-title`,
  confirmMsgOk: `${NAME_SPACE}-confirm-msg-ok`,
  confirmMsgCancel: `${NAME_SPACE}-confirm-msg-cancel`,
}
